<template>
    <div>
        <CRow class="m-0 justify-content-center align-items-center">
            <div class="text-center">
                <!-- Full-width image -->
                <img class="w-100" src="../assets/img/mask.png" alt="Mask Image" />
    
                <div class="bg-white-radius p-2" style="position: relative; z-index: 1;">
                    <h5 class="custom-title-app poppin-font mt-2">Select Country</h5>
                    <p class="custom-sub-title-app poppin-font">Choose your country</p>
    
                    <div class="p-40">
                        <v-select
                          v-model="selectedCountries"
                          :options="countryOptions"
                          label="CountryName"
                        ></v-select>
                    </div>
    
                    <div class="p-40 mt-2">
                        <div @click="GoToWho()" class="button-border-blue text-white">
                            <label class="mt-2">Continue</label>
                        </div>
                        <br /> <br /> <br />
                    </div>
                </div>
            </div>
        </CRow>
    </div>
</template>
  

<style scoped>
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>

<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
export default {
    data() {
    return {
      countryOptions: [],
      selectedCountries: null
    };
  },
  async mounted() {
    this.GetListCountries();
  },
    methods: {
        GoToWho() {
            this.$router.push("/WhoAreYou?countryId=" + this.selectedCountries.CountryId);
        },
        GetListCountries() {
        return this.$API
            .get(this.$GetListCountries)
            .then((response) => {
            if (response.status == 200) {
                this.countryOptions = response.data;
            }
            });
        },
    }
  }
</script>
  